<template>
    <div class="all" :class="{'exist-foot': !$slots.foot, 'exist-compare': $slots.compare}">
        <div id="main" v-show="!$slots.compare">
          <div class="banner"></div>
          <div class="content">
              <slot />
          </div>
          <div class="foot">
              <slot name="foot" />
          </div>
        </div>
        <slot name="compare" />
        <slot name="payback" />
        <slot name="loading" />
    </div>
</template>

<script>
export default {

}
</script>
<style lang="less">
@import 'index.less';
</style>
